const routers = []
const modules = import.meta.globEager('../../src/**/page.js')
for (const path in modules) {
  routers.push(modules[path])
}
export default routers
